<template>
  <app-base-main 
    parentTable
    class="profit-statistics-widget-msku">
    <template #filter-group>
      <app-filter-group @reset="$gjReset"
        @query="$gjNoticeQuery"
        :query-loading="queryBtnLoading">
        <gj-country-server-select v-model="filter.countryMarketValue"></gj-country-server-select>
        <gj-select :options="financeCurrencysOption"
          placeholder="币种"
          v-model="filter.currency"
          :clearable="false"></gj-select>
        <gj-select-date-picker :type="filter.date.key === 'DAY' ? 'daterange' : 'monthrange'"
          v-model="filter.date"
          :options="[
                {id: 'DAY', text: '日期'},
                {id: 'MONTH', text: '月份'},
              ]"
          :dateClearable="false"
          :shortcut="filter.date.key === 'DAY'"></gj-select-date-picker>
        <gj-select-input v-model="filter.keyword"
          :options="[
              {id: 'msku', text: 'MSKU', moreShow: true},
              {id: 'asin', text: 'ASIN', moreShow: true},
              {id: 'variationAsin', text: '父ASIN', moreShow: true},
              {id: 'sku', text: 'SKU'},
            ]"
          :width="['120px', '150px']"></gj-select-input>
        <template #advancedFilter>
          <gj-charger-select v-model="filter.sellingManagerIds"
            collapse-tags
            placeholder="全部负责人"
            style="width: 150px">
          </gj-charger-select>
          <gj-category-select multiple
            v-model="filter.categoryIds">
          </gj-category-select>
          <gj-brand-select v-model="filter.brandId"
            active>
          </gj-brand-select>
        </template>
        <template #right>
          <view-setting :ref="REF_VIEW_SETTING"
            save-mode="remote"
            :use-default="true"
            :module-name="moduleName"
            :config="model"
            :fn-generate-params="generateViewParams"
            @view-complete="handCompleteView"
            @view-change="handleChangeView">
            <template v-slot:dateRange="{ formData }">
              <gj-select style="width: 130px"
                v-model="formData.dateType"
                :options="DATE_TYPE_OPTIONS"
                :clearable="false"
                @change="() => formData.dateRange = 0"></gj-select>
              <gj-select style="margin-left: 8px;width: 130px;"
                v-model="formData.dateRange"
                :options="formData.dateType === 'DAY' ? timeRangeOptions : monthRangeOptions" />
            </template>
          </view-setting>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button type="primary"
        v-if="$permission('storageCostBatch:recalculate')"
        @click="clickRecalculate"> 重算 </gj-button>
    </template>
    <template #tool-group>
      <gj-tool-group :download="$permission('profitStatistics:export')"
        download-url="/operation/profitStatistics/export"
        :download-params="globalParams"
        help
        setting
        :task="true"
        @clickTask="reloadTaskNumber"
        :task-tip="taskProgressNumber"
        :table-name="tableName"
        :table-columns="columns"
        :sort-gjtable="$refs.gjTable">
        <template #task-content>
          <profit-statisrics-task ref="task"></profit-statisrics-task>
        </template>
      </gj-tool-group>
    </template>
    <template #table>
      <gj-table ref="gjTable"
        size="has-picture"
        adaptParent
        show-summary
        :name="tableName"
        :data="tableData"
        :columns="columns"
        :loading="loading"
        :pagination="pagination"
        :summary-object="statisticRecord"
        :default-sort="{prop: '', order: 'descending'}"
        @sort-change="$gjSortChange"
        @page-change="$gjNoticeQuery">
        <template v-slot:asin="{ row }">
          <gj-link :href="row.asinUrl" target="_blank">{{row.asin | defaultShow}}</gj-link>
        </template>
        <template v-slot:skuName="{ row }">
          <div height="100%">
            <gj-text width="90%">{{ row.skuName | defaultShow}}</gj-text>
          </div>
          <div v-if="!row.skuVOList || row.skuVOList.length == 0">{{row.sku | defaultShow}}</div>
          <gj-popover-panel v-else
            :width="'200px'"
            :data="row.skuVOList | skuVOList">
            {{row.sku | defaultShow}}
          </gj-popover-panel>
        </template>
        <template v-slot:platformCost="{ row }">
          <ProfitPopoverPanel title="平台费"
                            :width="'220px'"
                            :data="buildPlatformCost(row)">
            {{(row.currencySymbol || '')}}{{row.platformCost | defaultShow}}
          </ProfitPopoverPanel>
          <!-- <gj-popover-panel title="平台费"
                            :width="'220px'"
                            :data="buildPlatformCost(row)">
            {{(row.currencySymbol || '')}}{{row.platformCost | defaultShow}}
          </gj-popover-panel> -->
        </template>

        <template v-for="item in loop_fields"  v-slot:[item.field]="{row}">
          <div :key="item.field">
            <DataClickView @dataClick="handleClickColumn(row, item.field)" :text="(row[item.field]) | defaultShow(row[item.prefix],item.suffix)"/>
          </div>
        </template>
      </gj-table>
    </template>
  </app-base-main>
</template>

<script>
import { isMeaningfulMixin, queryMixin, selectionMixin,noRepeatQueryMixin } from "@/minxins";
import { convertToFullDate } from "@/utils/date.util.js";
import { financeCurrencysOption } from "@/utils/options";
// import { COLUMNS } from "@/views/modules/statistics/profit-statistics/config"
import { COLUMNS_2, loop_fields } from "./columns";
import { profitStatisticsPage } from "@/api/statistics"
import { DATE_SHORTCUTS } from "@/utils/const";
import profitStatisricsTask from "@/views/modules/statistics/profit-statistics/task/profit-statisrics-task"
import FinanceRecalculate from "@/views/modules/common/finance/finance-recalculate-modal";
import {getAllProgressCount, recalculateFinanceAnalysisReport} from "@/api/statistics";
import {isMeaningful} from "@/utils/common";
import { DATE_TYPE_OPTIONS, timeRangeOptions, monthRangeOptions } from '@/utils/options'
import viewConfig from './viewConfig/MSKU'
import {convertToDate, convertToMonth} from "@/utils/date.util";
import { generatorTrulyDateTime, buildPlatform } from './utils'
import ProfitPopoverPanel from "./profit-popover-panel.vue";
import DataClickView from '@/views/modules/statistics/common/analysis/goods-analysis/widget/data-click-view';
import OperationAnalysisModalNew from "modules/sale/listing/modal/operation-analysis-modal-new";

let COLUMNSMap = COLUMNS_2.filter(item => item.includesType.includes('msku'))



export default {
  mixins: [queryMixin, selectionMixin, isMeaningfulMixin, noRepeatQueryMixin, buildPlatform],
  name: "profit-statistics-msku",
  components: {profitStatisricsTask, ProfitPopoverPanel, DataClickView},
  mounted() {},
  data() {
    return {
      DATE_TYPE_OPTIONS,
      timeRangeOptions,
      monthRangeOptions,
      financeCurrencysOption: financeCurrencysOption, // 币种
      taskProgressNumber: null,
      loading: false, // 加载
      groupType: "msku",
      tableName: "profit-statistics-msku",
      statisticRecord: {}, // 合计对象
      tableData: [], // 表格数据
      filter: {
        timeStamp:null,
        countryMarketValue: {}, // 店铺国家
        categoryIds: null, //品类
        brandId: null, // 品牌
        sellingManagerIds: null, // 销售负责人
        currency: "", // 币种
        date: { key: 'DAY', value: DATE_SHORTCUTS.yesterday.date }, // 时间搜索
        keyword: {
          key: "msku",
          value: this.$route.query.routeValue||null,
          popover: false
        }, // 关键词搜索
      },
      columns: [
        { id: "picture", header: "图片", field: "picture:imageUrl", width: "100px", default: true, disabled: true, fixed: 'left'},
        { id: "msku", header: "MSKU", field: "msku", minWidth: "140px", default: true, fixed: 'left', copyable:true, sortable:true},
        { id: "marketName", header: "店铺/国家", field: "marketName", minWidth: "120px", default: true, fixed: 'left'},
        { id: "asin", header: "ASIN", field: "slot:asin",minWidth: "140px", default: true, fixed: 'left', sortable:true},
        { id: "crawlTitle", header: "商品标题", field: "crawlTitle", minWidth: "300px", overflowLine: 2},
        { id: "skuName", header: "产品名称/SKU", field: "slot:skuName", minWidth: "150px", sortable:true, sortBy:'sku'},
        { id: "sellingManagerNames", header: "负责人", field: "sellingManagerNames", minWidth: "100px", overflowLine: 1},
        { id: "variationAsin", header: "父ASIN", field: "variationAsin", minWidth: "100px"},
        { id: "categoryName", header: "品类", field: "categoryName", minWidth: "100px"},
        { id: "brandName", header: "品牌", field: "brandName", minWidth: "90px"},
        ...COLUMNSMap
      ],
      moduleName: 'PROFIT-STATISTICS',
      model: viewConfig,
      cacheOptions: {
        useCache: true,
      },
      loop_fields
    };
  },
  filters: {
    skuVOList(val = []) {
      return val.reduce((arr, item) => arr.concat({ label: item.col2, value: item.col1 }), [{label: '产品名称', value: 'SKU', bold: true}])
    }
  },
  activated(){
    // 再次进入已被缓存的此页时
    // 若路由中查询参数timeStamp变化时，则为从其他页面点击跳转至此，重新初始化查询参数
    if(this.$route.query.timeStamp!==this.filter.timeStamp){
      this.$gjQueryInit()
      this.$gjNoticeQuery()
    }
  },
  created() {
    this.sort.prop = ""
    this.reloadTaskNumber()
    this.filter.timeStamp = null
  },
  methods: {
    /**
     * 构造视图参数
     */
    generateViewParams (params) {
      let [ startDateTime = '', endDateTime = '' ] = generatorTrulyDateTime(params.dateType, params.dateRange)
      params.startDateTime = params.dateType === 'DAY' ? convertToDate(startDateTime) : convertToMonth(startDateTime)
      params.endDateTime = params.dateType === 'DAY' ? convertToDate(endDateTime) : convertToMonth(endDateTime)
      return Promise.resolve(params)
    },

    // 查询参数初始化
    $gjQueryInitParams() {
      this.filter = {
        timeStamp:this.$route.query.timeStamp,
        countryMarketValue: this.$route.query.timeStamp?{
          countryIds:this.$route.query.countryIds.split(','),
          marketIds:this.$route.query.marketIds.split(',')
        }:{}, // 店铺国家
        categoryIds: null, //品类
        brandId: null, // 品牌
        sellingManagerIds: null, // 销售负责人
        currency: "", // 币种
        date: {key: 'DAY', value: DATE_SHORTCUTS.yesterday.date}, // 时间搜索
        keyword: {
          key: "msku",
          value: this.$route.query.timeStamp?this.$route.query.routeValue:null,
          popover: false
        }, // 关键词搜索
      };
      // this.filter.countryMarketValue = {};
      // this.filter.keyword.value = null;
      // this.filter.categoryIds= null;
      // this.filter.brandId= null;
      // this.filter.sellingManagerIds= null;
      // this.filter.currency = "";
      // this.filter.date.key = "DAY";
      // this.filter.keyword.key = "msku";
      // this.filter.date.value = DATE_SHORTCUTS.yesterday.date;
    },

    // 查询参数重置
    $gjQueryResetParams() {
      this.filter = {
        timeStamp:this.$route.query.timeStamp,
        countryMarketValue: {}, // 店铺国家
        categoryIds: null, //品类
        brandId: null, // 品牌
        sellingManagerIds: null, // 销售负责人
        currency: "", // 币种
        date: {key: 'DAY', value: DATE_SHORTCUTS.yesterday.date}, // 时间搜索
        keyword: {
          key: "msku",
          value: null,
          popover: false
        }, // 关键词搜索
      };
    },
    /**
     *
     * @param params 查询条件参数
     * @override queryMixin
     * @returns {{ countryMarketValue: *}}
     */
    $gjCacheCallback(params) {
      return {
        countryMarketValue: params.countryMarketValue,
        date: params.date,
        currency: params.currency,
      };
    },
    // 搜索
    $gjQuery() {
      // 构造查询参数
      this.loading = true
      this.queryBtnLoading = true
      const params = {
        model: {
          groupType: this.groupType,
          countryCodes: this.filter.countryMarketValue.countryIds, // 国家
          marketIds: this.filter.countryMarketValue.marketIds, // 店铺
          currency: this.filter.currency, // 币种
          dateRangType: this.filter.date.key, // 统计日期范围
          startStatisticsDate: null, // 开始时间
          endStatisticsDate: null, // 结束时间
          msku: null, // msku
          asin: null, // asin
          variationAsin: null, // variationAsin
          sku: null, // sku
          sellingManagerIds: this.filter.sellingManagerIds, // 负责人
          categoryIds: this.filter.categoryIds, // 品类
          brandId: this.filter.brandId, // 品牌
        },
        ...this.querySort,
        ...this.queryPagination,
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      if (this.filter.date.key == "DAY" && this.filter.date.value) {
        params.model.startStatisticsDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM-dd')
        params.model.endStatisticsDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM-dd')
      }else {
        params.model.startStatisticsDate = convertToFullDate(this.filter.date.value[0], 'yyyy-MM')
        params.model.endStatisticsDate = convertToFullDate(this.filter.date.value[1], 'yyyy-MM')
      }
      this.globalParams = params;
      this.profitStatisticsPage(params)
    },
    // 跳转asin看板
    handleNavigateAsin (row) {
      const params = {
        asinType: 'child',
        asinCode: row.asin,
        countryData: {
          countryIds: row.countryCode ? [row.countryCode]: [], // 国家
          marketIds: row.marketId ? [row.marketId]: [], // 店铺
        },
        date: {
          type: 'DAY',
          value: this.filter.date.value && this.filter.date.value.length && this.filter.date.value[0] && this.filter.date.value[1] ? this.filter.date.value : []
        }
      }
      this.$router.push({ path: '/statistics/asin-361-analysis', query: { params: JSON.stringify(params)}})
    },
    // 查询list数据
    async profitStatisticsPage(params) {
      this.loading = true;
      this.queryBtnLoading = true
      try {
        let res = await profitStatisticsPage(params);
        this.pagination = this.getPagination(res);
        this.tableData = res.records || [];
        this.statisticRecord = res.statisticRecord;
      } finally {
        this.loading = false;
        this.queryBtnLoading = false
      }
    },
    clickRecalculate() {
      const _this=this;
      this.$gjCreate(FinanceRecalculate,{
        props: {
          requestPromise: recalculateFinanceAnalysisReport,
          requestProps: {
            startDate: 'startStatisticsDate',
            endDate: 'endStatisticsDate',
            marketIds: 'marketIds'
          },
          maxDayLength: 360,
          days: 13
        },
        on:{
          confirm(){
            _this.reloadTaskNumber();
          }
        }
      })
    },
    reloadTaskNumber() {
      getAllProgressCount()
              .then((data) => {
                if (isMeaningful(data) && !isNaN(data) && Number(data) !== 0) {
                  this.taskProgressNumber = data;
                } else {
                  this.taskProgressNumber = '';
                }
              });
      if (this.$refs && this.$refs.task) {
        this.$refs.task.$gjReset();
      }
    },

     /**
     * 显示弹窗
     */
    handleClickColumn(row, field){
      let params =  this.globalParams;
      let groupType = this.asinType;
      console.log(row, field, params, groupType)
      this.$gjCreate(OperationAnalysisModalNew,{
        props: {
          params:{
            ...params,
            groupType:'msku',
            date:[params.model.startStatisticsDate,params.model.endStatisticsDate],

            row:row,
            field:field
          }
          
        }
      })

    },

  }
};
</script>

<style scoped  lang="scss">
.profit-statistics-widget-msku {
  .table-shadow {
    box-shadow: none;
  }
  .date-picker {
    width: 136px;
  }
  .analysis-icon {
    font-size: 21px;
    color: #1F6EEF;
    cursor: pointer;
  }
}

// #el-popover-6932 div[style]{
//   text-align: right !important;
// }

// /deep/.wrapper-in{
//   .column-value--color {
//     text-align: right !important;
//   }
// // }
// /deep/ .column-value--color {
//   text-align: right !important;
// }


// div .column-value--color[style] {
//   text-align: right !important;
// }

</style>
